<template>
    <div class="container px-sm-1 " >
        <div id="eduCarousel" class="carousel" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#eduCarousel" :data-slide-to="0" class="active"></li>
                <li data-target="#eduCarousel" :data-slide-to="1" ></li>
                <li data-target="#eduCarousel" :data-slide-to="2" ></li>
                <li data-target="#eduCarousel" :data-slide-to="3" ></li>
            </ol>
            <div class="carousel-inner" >
                <div class="carousel-item active">
                    <img class="d-block" src="../../assets/CL.jpg" alt="First">
                    <div class="carousel-caption">
                        <p class="place">Coder's Lab</p>
                        <p class="period">Sept - Oct 2019</p>
                        <p class="info">Participated in a 7-weeks 8 hours a day, intensive course to become a front-end developer.</p>
                        <p class="info d-none d-md-block">The course emphasized practical exercise, with tests and homework.</p>
                        <p><a class="link" href="https://emilsprojects.site">Portfolio</a></p>

                    </div>
                </div>
                <div class="carousel-item">
                    <img class="d-block " src="../../assets/DWP.jpg" alt="Second slide">
                    <div class="carousel-caption">
                        <p class="place">Digital Web Properties</p>
                        <p class="title">Editor</p>
                        <p class="period">Aug 2016 - May 2017</p>
                        <p class="info">My main activity consisted in writing articles on a variety of subjects.</p>
                        <p class="info d-none d-md-block">Articles on technology, politics, science and nature for various
                            companies interested in being listed on Google News.</p>
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="d-block " src="../../assets/politcall.jpg" alt="Third slide">
                    <div class="carousel-caption">
                        <p class="place">PoliticAll</p>
                        <p class="title">Editor</p>
                        <p class="period">Nov 2013 - Mar 2015</p>
                        <p class="info">Writing articles on international politics for an independent online publication.</p>
                        <p class="info d-none d-md-block">Also researched and analyzed social and political developments around the world.</p>

                    </div>
                </div>
                <div class="carousel-item">
                    <img class="d-block" src="../../assets/SIE.jpg" alt="Fourth slide">
                    <div class="carousel-caption">
                        <p class="place">Foreign Intelligence Service</p>
                        <p class="title">Intern</p>
                        <p class="period">Jul 2014 - Aug 2014</p>
                        <p class="info">My activity consisted in the gathering and analysis of information from open sources.</p>
                        <p class="info d-none d-md-block">I also wrote briefings, essays, participated in debates and other activities similar to those of an
                        intelligence analyst.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "ExpTimeline"

    }

</script>

<style scoped>
    .container {
        padding: 100px 0;
    }
    .carousel-inner {
        width: 100% !important;
    }
    .carousel-item {
        width: 100% !important;
    }
    .d-block {
        width: 50%;
        height: auto;
        box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.5);
    }
    .carousel-caption {
        height: 100%;
        width: 50%;
        left: 50%;
        top: 2%;
        font-size: 1.5vmax;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0 0 0 10px;
        justify-content: space-evenly;

    }
    p {
        padding: 2px 0;
        margin: 0;
    }
    .place {
        color: navy;
        font-size: 1.8vmax;
        font-weight: 700;
    }
    .title {
        color: lightskyblue;
        font-size: 1.7vmax;
    }
    .period {
        font-size: 1.3vmax;
        color: black;
    }
    .carousel-indicators {
        bottom: -50px;
        left: -50%;
    }
    .link {
        color: white;
        text-shadow: 0 0 8px blue;
    }
</style>